import React from "react";
import { API_Contacts, HandleApi } from "../contants/general.constants";
import { Card } from "./card/card";

export function ContactsComponent() {
 const [contact, setContact] = React.useState(null);

 HandleApi(API_Contacts, setContact, setContact);

 const cardContent = {
  header: "Why us",
  key: "contacts",
  description: "Why should you choose to work with us?",
  content: {},
 };

 const description =
  "Soft Forging Ltd. is a dynamic software development company with a dedicated team boasting over a decade of expertise.\n" +
  " We focus on understanding your vision and goals, delivering tailored, innovative solutions that exceed expectations.\n" +
  " Our compact size allows for agility and rapid implementation, ensuring a strong partnership to help you achieve outstanding success.";

 if (contact) {
  const contact_res = contact.results[0];
  cardContent.content = {
   subDescription: description,
   phone: contact_res.phone,
   address: contact_res.address,
   email: contact_res.email || "office@softforging.com",
  };
 }

 return <Card key="contact" props={{ card: cardContent, id: "contacts" }} />;
}
